<template>
  <div class="comps-container flex" @click.stop="close">
    <div class="use-comps-container" @click.stop>
      <div class="title">兑换优惠券</div>
      <div class="input-container">
        <input
          v-model="couponsText"
          type="text"
          placeholder="请输入兑换码"
          class="comps-input"
        />
        <span class="comps-tips cursor_p" @click.stop="clickSubmit">
          兑换
        </span>
      </div>
      <div class="comps-container-choose">
        <div
          class="page left"
          @click.stop="handleClickTo(1)"
          v-show="couponsList.length > 1 && couponsIndex != 0"
        >
          <i class="iconfont iconchevron-left"></i>
        </div>
        <div
          class="page right"
          @click.stop="handleClickTo(-1)"
          v-show="
            couponsList.length > 1 && couponsIndex != -(couponsList.length - 1)
          "
        >
          <i class="iconfont iconchevron-right"></i>
        </div>
        <div
          v-if="couponsList.length > 0"
          class="coupons-list"
          :style="{ width: `${460 * couponsList.length}px` }"
        >
          <div
            class="list-container"
            v-for="(list, index) in couponsList"
            :key="index"
            :style="{ transform: `translateX(${couponsIndex * 460}px)` }"
          >
            <div
              class="list-item"
              v-for="(item, index1) in list"
              :key="index1"
              :class="{ active: item.id == tempComps.id }"
              @click="handleClickSelectCoupons(item)"
            >
              <div class="item-pic" v-if="item.cent">
                ¥ <span>{{ item.cent / 100 }}</span>
              </div>
              <div class="item-pic" v-if="item.discount">
                <span>{{ item.discount * 10 }}折</span>
              </div>
              <div class="item-pic" v-if="item.member_days">
                <span>{{ item.member_days }}天</span>
              </div>
              <div class="item-text-time">
                <p>{{ item.coupon_name || item.name }}</p>
                <p>有效期：{{ moment(item.expiry).format("YYYY-MM-DD") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-container flex">
        <div class="btn cancel-btn cursor_p" @click="close">取消</div>
        <div class="btn use-btn cursor_p" @click="useComps">使用</div>
      </div>
    </div>
  </div>
</template>
<script>
import { get_tUser } from "@/assets/js/util";
import api from "@/api";
const moment = require("moment");

export default {
  name: "CouponModal",
  data() {
    return {
      couponsText: "",
      couponsList: [],
      couponsIndex: 0,
      tempComps: {},
      moment,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleClickTo(value) {
      this.couponsIndex += value;
    },
    useComps() {
      if (!this.tempComps.id) {
        this.$message.error("请选择优惠券");
        return;
      }
      this.$emit("useComps", this.tempComps);
      this.close();
    },
    //选择优惠券
    handleClickSelectCoupons(obj) {
      if (this.tempComps.id === obj.id) {
        this.tempComps = {};
      } else {
        this.tempComps = obj;
      }
    },
    //提交兑换码
    async clickSubmit() {
      if (!this.couponsText) {
        this.$message.error("无效兑换码，请检查");
        return;
      }
      let datas = {
        partner: this.couponsText,
        plan: "校招会员",
      };
      let res = await api.account.couponsCreate(get_tUser().c_t, datas);
      if (res.code === 1000) {
        this.couponsList = [];
        let coupons = res.data.coupons.filter((item) => item.usable);
        for (let i = 0; i < coupons.length; i += 2) {
          this.couponsList.push(coupons.slice(i, i + 2));
        }
        this.couponsText = "";
        this.$message.success(res.data.message);
      } else {
        this.$message.error(res.data ? res.data.error : res.message);
      }
    },
    async fetchCouponListData() {
      try {
        const res = await api.account.getSpecialOffers(get_tUser().c_t, {
          coupon_plan: "校招会员",
        });
        if (res.code === 1000) {
          let coupons = res.data.coupons.filter((item) => item.usable);
          for (let i = 0; i < coupons.length; i += 2) {
            this.couponsList.push(coupons.slice(i, i + 2));
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchCouponListData();
  },
};
</script>
<style lang="scss" scoped>
.comps-container {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  .use-comps-container {
    width: 524px;
    //height: 202px;
    padding: 24px 32px 28px;
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-weight: 600;
      color: #404040;
    }
    .input-container {
      width: 100%;
      height: 36px;
      margin-top: 26px;
      border-radius: 2px;
      border: 1px solid #ececec;
      position: relative;
      .comps-input {
        width: 100%;
        height: 100%;
        padding: 11px 32px 11px 16px;
        box-sizing: border-box;
        outline: none;
      }
      .comps-tips {
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        position: absolute;
        top: 11px;
        right: 16px;
      }
    }
    .comps-container-choose {
      width: 100%;
      overflow: hidden;
      position: relative;
      .page {
        position: absolute;
        width: 24px;
        height: 32px;
        background: rgba(65, 70, 83, 0.5);
        top: 32px;
        cursor: pointer;
        z-index: 20;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          background: rgba(65, 70, 83, 0.8);
        }

        &.left {
          left: 0;
          border-radius: 0px 100px 100px 0px;
        }

        &.right {
          right: 0;
          border-radius: 100px 0px 0px 100px;
        }

        & > i {
          font-size: 24px;
          color: #fff;
        }
      }
      .coupons-list {
        width: 460px;
        height: 101px;
        background: #fff;
        display: flex;
        flex-wrap: nowrap;
        overflow: hidden;
        border-radius: 0px 0px 8px 8px;

        .list-container {
          display: flex;
          width: 460px;
          //padding: 0 16px;
          align-items: center;
          justify-content: space-between;
          transition: all 0.4s;
          position: relative;
          z-index: 10;

          .list-item {
            width: 226px;
            height: 64px;
            background-image: url("https://files.wondercv.com/web/member/defult.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-right: 8px;
            padding: 16px 12px;
            align-items: center;
            box-sizing: border-box;
            display: flex;
            cursor: pointer;

            .item-pic {
              width: 42px;
              height: 22px;
              font-size: 12px;
              text-align: center;
              font-weight: 400;
              color: rgba(255, 102, 68, 1);
              line-height: 22px;
              margin-right: 16px;
              color: #404040;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              span {
                font-size: 16px;
              }
            }

            .item-text-time {
              flex: 1;
              text-align: center;
              font-size: 12px;
              font-weight: 300;
              display: flex;
              align-items: center;
              flex-direction: column;

              & > p {
                width: 111px;
                margin: 0 auto;
                white-space: nowrap;
                line-height: 100%;
              }

              & > p:first-child {
                color: #404040;
                margin-bottom: 8px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              & > p:last-child {
                color: #9c9c9c;
                font-weight: 300;
              }
            }

            &:last-child {
              margin-right: 0px;
            }

            &:hover {
              background-image: url("https://files.wondercv.com/web/member/hover.png");

              .item-pic {
                color: #ff6644;
              }

              .item-text-time {
                & > p {
                  color: #ff6644;
                }
              }
            }

            &.active {
              background-image: url("https://files.wondercv.com/web/member/active.png");

              .item-pic {
                color: #ff6644;
              }

              .item-text-time {
                & > p {
                  color: #ff6644;
                }
              }
            }
          }
        }
      }
    }
    .btn-container {
      margin-top: 28px;
      width: 100%;
      justify-content: flex-end;
      .btn {
        width: 84px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        font-size: 14px;
        &:hover {
          opacity: 0.8;
        }
      }
      .cancel-btn {
        color: #606060;
      }
      .use-btn {
        color: #fff;
        margin-left: 16px;
        background-color: #ff6644;
        border-color: #ff6644;
      }
    }
  }
}
</style>
